import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin, onShowCadastro }) => {
  const [formData, setFormData] = useState({
    operadorId: '',
    email: '',
    senha: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [operadores, setOperadores] = useState([]);
  const [loadingOperadores, setLoadingOperadores] = useState(true);


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpar erro do campo quando usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.operadorId) {
      newErrors.operadorId = 'Selecione uma operação';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    if (!formData.senha.trim()) {
      newErrors.senha = 'Senha é obrigatória';
    } else if (formData.senha.length < 6) {
      newErrors.senha = 'Senha deve ter pelo menos 6 caracteres';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Função para validar email
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Autenticar usuário via API
      const response = await fetch('https://vega-solutions.site/api/auth.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operador_id: formData.operadorId,
          email: formData.email,
          senha: formData.senha
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        // Salvar dados de login se "lembrar de mim" estiver marcado
        if (formData.rememberMe) {
          localStorage.setItem('rememberedUser', JSON.stringify({
            operadorId: formData.operadorId,
            email: formData.email
          }));
        }
        
        // Chamar função de login do componente pai
        onLogin({
          userId: data.usuario.id,
          nome: data.usuario.nome,
          email: data.usuario.email,
          cargo: data.usuario.cargo,
          operadorId: data.usuario.operador_id,
          ascCode: data.usuario.asc_code,
          operadorNome: data.usuario.operador_nome,
          cnpj: data.usuario.cnpj,
          role: 'usuario',
          loginTime: new Date().toISOString()
        });
      } else {
        setErrors({ 
          general: data.error || 'Credenciais inválidas. Verifique email e senha.' 
        });
      }
    } catch (error) {
      setErrors({ 
        general: 'Erro ao fazer login. Verifique se o servidor está rodando e tente novamente.' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Carregar operadores e usuário lembrado ao montar o componente
  React.useEffect(() => {
    // Carregar operadores
    const loadOperadores = async () => {
      try {
        const response = await fetch('https://vega-solutions.site/api/operadores.php');
        const data = await response.json();
        
        if (response.ok && data.success) {
          setOperadores(data.operadores);
        }
      } catch (error) {
        console.error('Erro ao carregar operadores:', error);
      } finally {
        setLoadingOperadores(false);
      }
    };
    
    loadOperadores();
    
    // Carregar usuário lembrado
    const rememberedUser = localStorage.getItem('rememberedUser');
    if (rememberedUser) {
      try {
        const userData = JSON.parse(rememberedUser);
        setFormData(prev => ({
          ...prev,
          operadorId: userData.operadorId || '',
          email: userData.email || '',
          rememberMe: true
        }));
      } catch (error) {
        // Se não conseguir fazer parse, limpar dados inválidos
        localStorage.removeItem('rememberedUser');
      }
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
          <div className="shape shape-5"></div>
        </div>
      </div>
      
      <div className="login-content">
        <div className="login-card">
          <div className="login-left">
            <div className="login-branding">
              <div className="brand-logo">
                <div className="logo-icon">
                  <img src="/global_express.png" alt="Global Express Logo" className="vega-logo" />
                </div>
              </div>
              
              <div className="brand-features">
                <div className="feature-item">
                  <div className="feature-icon">👁️</div>
                  <div className="feature-text">
                    <h3>Visão Completa</h3>
                    <p>Controle total do seu estoque em tempo real</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">⚡</div>
                  <div className="feature-text">
                    <h3>Gestão Avançada</h3>
                    <p>Ferramentas inteligentes para otimização</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">📈</div>
                  <div className="feature-text">
                    <h3>Análise Inteligente</h3>
                    <p>Relatórios e insights para decisões estratégicas</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="login-right">
            <div className="login-form-container">
              <div className="form-header">
                <h2>Bem-vindo ao VEGA!</h2>
                <p>Faça login para acessar sua visão de estoque</p>
              </div>
              
              <form className="login-form" onSubmit={handleSubmit}>
                {errors.general && (
                  <div className="error-message error-general">
                    <span className="error-icon">⚠️</span>
                    {errors.general}
                  </div>
                )}
                
                <div className="form-group">
                  <label htmlFor="operadorId" className="form-label">
                    <span className="label-icon">🏢</span>
                    Operação
                  </label>
                  <select
                    id="operadorId"
                    name="operadorId"
                    value={formData.operadorId}
                    onChange={handleInputChange}
                    className={`form-input ${errors.operadorId ? 'error' : ''}`}
                    disabled={isLoading || loadingOperadores}
                  >
                    <option value="">Selecione uma operação</option>
                    {operadores.map(operador => (
                      <option key={operador.id} value={operador.id}>
                        {operador.nome} - {operador.asc_code}
                      </option>
                    ))}
                  </select>
                  {errors.operadorId && (
                    <span className="field-error">{errors.operadorId}</span>
                  )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    <span className="label-icon">📧</span>
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`form-input ${errors.email ? 'error' : ''}`}
                    placeholder="Ex: usuario@empresa.com"
                    disabled={isLoading}
                  />
                  {errors.email && (
                    <span className="field-error">{errors.email}</span>
                  )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="senha" className="form-label">
                    <span className="label-icon">🔒</span>
                    Senha
                  </label>
                  <input
                    type="password"
                    id="senha"
                    name="senha"
                    value={formData.senha}
                    onChange={handleInputChange}
                    className={`form-input ${errors.senha ? 'error' : ''}`}
                    placeholder="Digite sua senha"
                    disabled={isLoading}
                  />
                  {errors.senha && (
                    <span className="field-error">{errors.senha}</span>
                  )}
                </div>
                
                <div className="form-options">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="rememberMe"
                      checked={formData.rememberMe}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                    <span className="checkbox-custom"></span>
                    <span className="checkbox-text">Lembrar de mim</span>
                  </label>
                </div>
                
                <button
                  type="submit"
                  className={`login-button ${isLoading ? 'loading' : ''}`}
                  disabled={isLoading}
                  style={{
                    transform: isLoading ? 'scale(0.98)' : 'scale(1)',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {isLoading ? (
                    <>
                      <div className="loading-spinner"></div>
                      <span>Entrando...</span>
                    </>
                  ) : (
                    <>
                      <span className="button-icon">🚀</span>
                      <span>Entrar no VEGA</span>
                    </>
                  )}
                </button>
                
                {onShowCadastro && (
                  <div className="login-footer">
                    <p>Não tem uma conta?</p>
                    <button
                      type="button"
                      className="cadastro-button"
                      onClick={onShowCadastro}
                      disabled={isLoading}
                    >
                      <span className="button-icon">👤</span>
                      Cadastrar Usuário
                    </button>
                  </div>
                )}
              </form>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
